import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { Staffs, StaffsFilters } from '@/modules/staffs/types/';
import { Organizations } from '@/modules/organizations/types';

import { CompaniesUsers } from '../types';

interface CompaniesUsers extends BaseResponse, ApiPagination {
  data: {
    items: Staffs.Staff[];
    companies: Pick<Staffs.Staff, 'id' | 'name_company'>[];
  };
}

interface CompanyUserStaff extends BaseResponse, ApiPagination {
  data: {
    items: Staffs.Staff[];
    company: Organizations.Organization;
  };
}

export class CompaniesUsersService extends BaseApiService {
  private readonly base_path = 'admin/company';

  // получение информации с сервера о заказах и детальной информации о выбранном заказе

  async get_companies_users_managers(filters: FiltersPagination<Filters>): Promise<CompaniesUsers> {
    const payload = filters;

    const { data } = await this.http_client.get<CompaniesUsers>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_company_user_staff(
    filters: FiltersPagination<Filters>,
    id: string | number,
  ): Promise<CompanyUserStaff> {
    const payload = filters;
    const url = `${this.base_path}/staff/${id}`;
    const response = await this.http_client.get<CompanyUserStaff>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    const { data } = response;

    return data;
  }

  async update_manager_details(params: {
    company_id: number;
    payload: CompaniesUsers.StaffPayloadAdmin;
  }): Promise<BaseResponse> {
    const { company_id, payload } = params;

    const url = `${this.base_path}/${company_id}`;

    const { data } = await this.http_client.patch<BaseResponse>(url, payload);

    return data;
  }

  async update_staff_details(payload: CompaniesUsers.StaffPayloadAdmin): Promise<BaseResponse> {
    const url = `${this.base_path}/staff/${payload.user_id}`;

    const { data } = await this.http_client.patch<BaseResponse>(url, payload);

    return data;
  }
}

export const default_company_user_staff_filters = (): CompaniesUsers.CompanysUserStaffFilters => ({
  search: '',
  roles: [],
  is_active: null,
});

export const default_manager_new_details = (): Record<
  keyof Staffs.Staff,
  Staffs.Staff[keyof Staffs.Staff]
> => ({
  surname: '',
  name: '',
  email: '',
  patronymic: '',
});
